import { registerModal } from 'features/Modal/ModalRegistry'
import CasesViewModal from './CasesViewModal.container'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'CASES_VIEW_MODAL'
registerModal(modalType, CasesViewModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesViewModal/CasesViewModal.action.js